export enum CallAttempt {
  Zero = 0,
  One = 1,
  Two = 2,
  ThreePlus = 3,
}
